import React, { useState, useEffect } from "react";
import useAuth from "../../../../../../components/hooks/useAuth";
import Loader from "../../../../../../components/Loader";

const GruposOperation = ({
  campaignIds, // Recebe o array de IDs das campanhas selecionadas
  gruposSelecionados,
  setGruposSelecionados,
  setEtapaAtual,
  nextStep,
}) => {
  const { postApi } = useAuth();
  const [loading, setLoading] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [grupoPesquisa, setGrupoPesquisa] = useState("");
  const [mostrarGrupos, setMostrarGrupos] = useState(true);

  const notifyColor = window.notifyColor || "#51a197";

  const loadGroupRequest = async () => {
    if (!campaignIds || campaignIds.length === 0) return;

    setLoading(true);
    try {
      // Faz o post como solicitado no exemplo
      let response = await postApi("/api/v1/campaign/groups/list", {
        queryString: {
          campaign: {
            'id': campaignIds
          }
        }
      });

      if (response && response.lista) {
        setGroupList(response.lista);
      }
    } catch (error) {
      console.error("Erro ao carregar grupos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGroupRequest();
  }, [campaignIds]);

  const handleSelecionarGrupo = (id) => {
    if (gruposSelecionados.includes(id)) {
      setGruposSelecionados(gruposSelecionados.filter((g) => g !== id));
    } else {
      setGruposSelecionados([...gruposSelecionados, id]);
    }
  };

  const handleSelecionarTodosGrupos = () => {
    const filtrados = groupList.filter(g =>
      g.name.toLowerCase().includes(grupoPesquisa.toLowerCase())
    );

    if (gruposSelecionados.length === filtrados.length) {
      setGruposSelecionados([]);
    } else {
      setGruposSelecionados(filtrados.map(g => g.id));
    }
  };

  const gruposFiltrados = groupList.filter(g =>
    g.name.toLowerCase().includes(grupoPesquisa.toLowerCase())
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "10px",
        boxSizing: "border-box",
        background: "#fff",
      }}
    >
      <h3 style={{ color: "#005c53", marginBottom: 8, textAlign: "center", fontSize: "24px" }}>
        Selecione os Grupos
      </h3>
      <p style={{ color: "#666", marginBottom: 32 }}>Escolha para quais grupos a operação será aplicada</p>

      {/* Botão de Próximo */}
      <div style={{ position: "sticky", top: 0, background: "#fff", padding: "10px", zIndex: 10, width: "100%", display: "flex", justifyContent: "center", marginBottom: 20 }}>
        <button
          style={{
            background: gruposSelecionados.length > 0 ? notifyColor : "#d1d5db",
            color: "#fff",
            border: "none",
            borderRadius: "12px",
            padding: "12px 40px",
            fontWeight: "bold",
            fontSize: 16,
            cursor: gruposSelecionados.length > 0 ? "pointer" : "not-allowed",
            boxShadow: gruposSelecionados.length > 0 ? `0 4px 14px ${notifyColor}44` : "none",
            transition: "all 0.3s ease",
          }}
          onClick={() => {
            if (gruposSelecionados.length > 0) {
              setEtapaAtual(nextStep);
            }
          }}
          disabled={gruposSelecionados.length === 0}
        >
          Próxima Etapa ({gruposSelecionados.length})
        </button>
      </div>

      <div style={{ width: "100%", maxWidth: 600, display: "flex", flexDirection: "column", gap: 20 }}>

        {/* Toggle Visualização */}
        <button
          onClick={() => setMostrarGrupos(!mostrarGrupos)}
          style={{
            background: "#f1f5f9",
            color: "#475569",
            border: "1px solid #e2e8f0",
            borderRadius: 8,
            padding: "10px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          {mostrarGrupos ? "Ocultar Lista de Grupos" : "Mostrar Lista de Grupos"}
        </button>

        {mostrarGrupos && (
          <div style={{ background: "#f8fafc", borderRadius: 16, padding: 20, border: "1px solid #e2e8f0" }}>
            <input
              type="text"
              placeholder="Pesquisar por nome do grupo..."
              value={grupoPesquisa}
              onChange={(e) => setGrupoPesquisa(e.target.value)}
              style={{
                width: "100%",
                padding: "12px 16px",
                borderRadius: 10,
                border: "1px solid #cbd5e1",
                marginBottom: 16,
                fontSize: 15,
                outline: "none"
              }}
            />

            <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <input
                type="checkbox"
                id="checkAllGroups"
                checked={gruposFiltrados.length > 0 && gruposSelecionados.length === gruposFiltrados.length}
                onChange={handleSelecionarTodosGrupos}
                style={{ width: 18, height: 18, cursor: "pointer", accentColor: notifyColor }}
              />
              <label htmlFor="checkAllGroups" style={{ fontWeight: "600", color: "#1e293b", cursor: "pointer" }}>
                Selecionar todos os grupos filtrados
              </label>
            </div>

            {loading ? (
              <div style={{ padding: 40, textAlign: "center" }}><Loader /></div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10, maxHeight: "400px", overflowY: "auto", padding: "4px" }}>
                {gruposFiltrados.length === 0 ? (
                  <div style={{ textAlign: "center", color: "#64748b", padding: 20 }}>Nenhum grupo encontrado</div>
                ) : (
                  gruposFiltrados.map((grupo) => (
                    <div
                      key={grupo.id}
                      onClick={() => handleSelecionarGrupo(grupo.id)}
                      style={{
                        background: gruposSelecionados.includes(grupo.id) ? "#f0fdf4" : "#fff",
                        borderRadius: 12,
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        border: `1px solid ${gruposSelecionados.includes(grupo.id) ? notifyColor : "#e2e8f0"}`,
                        cursor: "pointer",
                        transition: "all 0.2s"
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={gruposSelecionados.includes(grupo.id)}
                        onChange={() => { }} // Handle no click da div
                        style={{ width: 18, height: 18, accentColor: notifyColor }}
                      />

                      <div style={{ position: "relative" }}>
                        <img
                          src={grupo.picture_url || `https://ui-avatars.com/api/?name=${grupo.name}`}
                          alt={grupo.name}
                          style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover", border: "1px solid #ddd" }}
                        />
                        {grupo.is_full && (
                          <span title="Grupo Lotado" style={{ position: "absolute", top: -2, right: -2, width: 12, height: 12, background: "#ef4444", borderRadius: "50%", border: "2px solid #fff" }} />
                        )}
                      </div>

                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: "bold", color: "#1e293b", fontSize: 14 }}>{grupo.name} - #{grupo.position}</div>
                        <div style={{ fontSize: 11, color: "#64748b" }}>{grupo.whatsapp_id}</div>
                      </div>

                      <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "right" }}>
                        {grupo.qtd_members} / {grupo.max_members}
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <style>
        {`
          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 #51a197; }
            70% { box-shadow: 0 0 8px 6px #51a19744; }
            100% { box-shadow: 0 0 0 0 #51a197; }
          }
        `}
      </style>
    </div>
  );
};

export default GruposOperation;